export default __webpack_public_path__ + "static/media/logoNavbar.19f7fd6c.png";